import React from 'react';
import Ballotpaper from '../components/Ballotpaper.js';

const ElectionVote = () => {
  const styles = `
    .election-body {
      margin: 0;
      padding: 0;
      min-height: 100vh;
      font-family: 'FoundryContextW03Md', Helvetica, sans-serif;
      background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
      color: #ffffff;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
    }

    .election-container {
      width: 100%;
      max-width: 900px;
      padding: 40px 20px 60px;
    }

    /* Mini header */
    .election-mini-header {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-bottom: 30px;
    }

    .back-link {
      color: #9c59d1;
      text-decoration: none;
      font-weight: 600;
      font-size: 0.95rem;
      transition: opacity 0.2s ease;
    }

    .back-link:hover {
      opacity: 0.7;
    }

    .mini-title {
      font-family: 'FoundryContextW03Bd', Helvetica, sans-serif;
      font-size: 1.8rem;
      font-weight: 900;
      letter-spacing: -1px;
      margin: 0;
      text-transform: uppercase;
    }

    .mini-desc {
      margin-top: 6px;
      font-size: 0.95rem;
      color: #a0a0c5;
      max-width: 500px;
      line-height: 1.6;
    }

    .election-line {
      border: none;
      height: 2px;
      background: linear-gradient(
        90deg,
        #9c59d1 0%,
        rgba(156, 89, 209, 0) 100%
      );
      margin: 30px 0;
    }

    /* Ballot wrapper */
    .ballot-wrapper {
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid rgba(156, 89, 209, 0.15);
      padding: 30px;
    }

    @media (max-width: 768px) {
      .election-container {
        padding: 30px 16px 50px;
      }

      .mini-title {
        font-size: 1.5rem;
      }
    }
  `;

  return (
    <div className="election-body">
      <style>{styles}</style>

      <div className="election-container">
        {/* Mini Header */}
        <header>
          <div className="election-mini-header">
            <a href="/election" className="back-link">
              ← Back
            </a>
            <div>
              <h1 className="mini-title">Cast Your Vote</h1>
              <p className="mini-desc">
                Select one option for Proportional Representation of 2026 Parliamentary Election. Your vote is sent to EMI Database cannot be modified after submission.
              </p>
            </div>
          </div>
        </header>

        <hr className="election-line" />

        {/* Ballot */}
        <section className="ballot-wrapper">
          <Ballotpaper />
        </section>
      </div>
    </div>
  );
};

export default ElectionVote;
